import ApiConnector from "@/repository/connector";

class Departments {
  async get() {
    const result = {
      value: null,
      error: null,
    };
    const response = await ApiConnector.connector.get(`/v1/departments/me/`);
    result.value = response.data;
    result.error = response.detail;
    return result;
  }

  async getWorkDays() {
    const result = {
      value: null,
      error: null,
    };
    const response = await ApiConnector.connector.get(
      `/v1/work-time/departments/`,
    );
    result.value = response.data;
    result.error = response.detail;
    return result;
  }
}

export default new Departments();
